/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./wxOpenButton.vue?vue&type=template&id=701a1af3&"
import script from "./wxOpenButton.vue?vue&type=script&lang=js&"
export * from "./wxOpenButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.8.1_webpack@5.89.0__lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports